import { FormGroup } from '@angular/forms';
import { PaginationForm } from './pagination.model';
import { SelectData } from './select-input.model';
import { ModelForm } from './form-helpers.model';

export interface ProcessingReceivablesFilter {
  fundo: SelectData;
  status: SelectData;
  tipoRecebivel: SelectData;
  seuNumero: string;
  numeroDocumento: string;
  dataAquisicao: string;
  dataVencimento: string;
  nomeSacado: string;
  cpfCnpjSacado: string;
  nomeCedente: SelectData;
}
